import { useTranslation } from 'react-i18next';

import { useProductCenterApi } from 'api';
import { useQueryLineOfBusiness } from 'api/queries';
import { MainSegment } from 'api/responses/models/Unit/UnitStructure/MainSegment';
import { InlineDisplayValue } from 'library/components/controls/display/InlineDisplayValue';
import { TextDisplay } from 'library/components/controls/display/TextDisplay';
import { EmptyTextData } from 'library/types';

export const LineOfBusinessDisplay = ({
	mainSegment,
	lineOfBusiness,
	inline = false,
}: {
	mainSegment: MainSegment | null;
	lineOfBusiness: string | null;
	inline?: boolean;
}): React.JSX.Element => {
	const { t } = useTranslation('unitCreation');

	const { api } = useProductCenterApi();
	const lineOfBusinessQuery = useQueryLineOfBusiness(api, mainSegment);

	const lineOption = lineOfBusiness
		? lineOfBusinessQuery.data?.find(
				(line) =>
					line.value.localeCompare(lineOfBusiness, undefined, {
						sensitivity: 'accent',
					}) === 0
			)
		: null;

	const renderDisplay = (label: string, value: EmptyTextData) => {
		return inline ? (
			<InlineDisplayValue label={label} value={value} />
		) : (
			<TextDisplay label={label} value={value} />
		);
	};

	return renderDisplay(
		t('configuration-select-line-of-business'),
		lineOption?.text ?? lineOfBusiness
	);
};
